const floatingBanner = document.querySelector(".floating-banner");
const closeButton = document.querySelector("#banner-close");
const popupWindow = document.querySelector(".banner-popup");

function onCloseButtonClicked() {
  floatingBanner.classList.add("floating-banner-invisible");
}

function onBannerClicked() {
  popupWindow.classList.add("active");
}

window.addEventListener("load", (event) => {
  const oneTrustBanner = document.querySelector("#onetrust-banner-sdk");
  floatingBanner.style.bottom = (oneTrustBanner.clientHeight + 20) + "px";

  const observer = new MutationObserver(records => {
    floatingBanner.style.bottom = (oneTrustBanner.clientHeight + 20) + "px";
  });

  const resizeObserver = new ResizeObserver(elements => {
    floatingBanner.style.bottom = (oneTrustBanner.clientHeight + 20) + "px";
  });

  observer.observe(oneTrustBanner, { attributes: true, attributeFilter: ["style"] });
  resizeObserver.observe(oneTrustBanner);
});

closeButton.onclick = onCloseButtonClicked;
floatingBanner.onclick = onBannerClicked;